
// import React, {
//   useCallback,
//   useContext,
//   useEffect,
//   useRef,
//   useState,
// } from "react";
// import { NavLink, useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import { ConfigContext } from "../../Context/ConfigContext";
// import slugify from "slugify";
// import { Helmet } from "react-helmet";
// import { toast } from "react-toastify";
// import { AddToCartNotifier } from "../../Components/CartComponents";
// import * as XLSX from "xlsx";
// import { axiosGet, axiosPost } from "../../Apis/axiosMethods";
// import { CartsContext } from "../../Context/CartsContext";

// const POLL_INTERVAL = 2000;

// const BulkPricing = () => {
//   const {
//     apiURL,
//     setIsCartDropdownOpen,
//     apiHeaderFile,
//     currency,
//     business_type
//   } = useContext(ConfigContext);

//   const {
//     AddToCart,
//     GetCartItemQty,
//     GetStockPolicyItem
//   } = useContext(CartsContext);

//   const isAddingRef = useRef(false);
//   const [addToCartLoading, setAddToCartLoading] = useState(false);

//   const navigate = useNavigate();

//   const [selectedFile, setSelectedFile] = useState(null);
//   const [uploading, setUploading] = useState(false);
//   const [loadingResults, setLoadingResults] = useState(false);

//   const [jobId, setJobId] = useState(null);
//   const [jobStatus, setJobStatus] = useState("");
//   const [resultGroups, setResultGroups] = useState([]);
//   const [jobError, setJobError] = useState("");

//   const pollTimeoutRef = useRef(null);
//   const activeJobRef = useRef(null);

//   useEffect(() => {
//     return () => {
//       if (pollTimeoutRef.current) {
//         clearTimeout(pollTimeoutRef.current);
//       }
//     };
//   }, []);

//   // =====================================================
//   // ADD TO CART
//   // =====================================================

//   const handleAddToCart = async (part, url) => {
//     if (isAddingRef.current) return;
//     isAddingRef.current = true;

//     try {
//       setAddToCartLoading(true);

//       const prev_qty = Number(await GetCartItemQty(part?.ART_SEARCH_NUMBER));

//       const stock = Number(part?.VD_QTY);

//       if (!stock) {
//         toast.success(
//           <AddToCartNotifier
//             item_name={"We dont have stock for this part"}
//             item_img={""}
//           />
//         );
//         return;
//       }

//       // Get Stock Policy
//       const stockPolicy = await GetStockPolicyItem(
//         part?.ART_SEARCH_NUMBER,
//         part?.stock_oe,
//         part?.ART_SUP_ID,
//         part?.ART_SUP_BRAND
//       );

//       const minQty = Number(stockPolicy?.policy_min_qty || 1);

//       // Default quantity
//       let addQty = minQty;

//       // Remaining stock after cart quantity
//       const remainingStock = stock - prev_qty;

//       // If remaining stock is less than min qty, add remaining stock
//       if (remainingStock < minQty && remainingStock > 0) {
//         addQty = remainingStock;
//       }

//       if (remainingStock >= addQty) {

//         const partImg = part?.MEDIA_SOURCE ? part.MEDIA_SOURCE : `${apiURL}/public/placeholder_category.jpeg`;

//         const item = {
//           ART_ID: part?.ART_ID,
//           ART_ARTICLE_NR: part?.ART_SEARCH_NUMBER,
//           PRODUCT_GROUP_EN: part?.PRODUCT_GROUP,
//           stock_price_mrp: part?.VD_PRICE_MRP,
//           VD_BB_PRICE: part?.VD_BB_PRICE,
//           VD_BG_PRICE: part?.VD_BG_PRICE,
//           ART_SUP_ID: part?.ART_SUP_ID || 0,
//           ART_SUP_BRAND: part?.ART_SUP_BRAND,
//           inventory_store_id: part?.inventory_store_id,
//           stock_oe: part?.stock_oe ?? 0,
//           VD_QTY: stock,
//           stock_delivery_days: part?.stock_delivery_days,
//         };

//         await AddToCart(item, addQty, partImg, url);

//         setIsCartDropdownOpen(true);
//         window.scrollTo(0, 0);

//       } else {

//         toast.success(
//           <AddToCartNotifier
//             item_name={"We dont have enough stock for this part"}
//             item_img={""}
//           />
//         );

//       }

//     } catch (error) {
//       console.log("handleAddToCart Error:", error);
//     } finally {
//       setAddToCartLoading(false);
//       isAddingRef.current = false;
//     }
//   };

//   // =====================================================
//   // SELECT EXCEL FILE
//   // =====================================================

//   const handleFileChange = (event) => {
//     const file = event.target.files?.[0];

//     if (!file) {
//       setSelectedFile(null);
//       return;
//     }

//     const isExcelExtension = /\.(xlsx|xls)$/i.test(file.name);

//     if (!isExcelExtension) {
//       toast.error("Please select a valid Excel file (.xlsx or .xls).");
//       event.target.value = "";
//       setSelectedFile(null);
//       return;
//     }

//     setSelectedFile(file);
//     setJobError("");
//   };

//   // =====================================================
//   // FETCH BACKGROUND JOB RESULT
//   // =====================================================

//   const fetchJobData = useCallback(async (currentJobId) => {
//     if (!currentJobId) return;

//     try {
//       const response = await axiosGet(
//         "/Parts/GetBulkPricingJobResult",
//         { jobId: currentJobId, currency }
//       );

//       const payload = response?.data;

//       if (!payload?.success) {
//         throw new Error(
//           payload?.message || "Unable to retrieve processing status."
//         );
//       }

//       // Ignore an old request if a different job has been started.
//       if (activeJobRef.current !== currentJobId) return;

//       const status = String(payload.status || "processing").toLowerCase();

//       setJobStatus(status);

//       // Expected backend format:
//       // data: [{ oeNumber: "123", parts: [...] }]
//       if (Array.isArray(payload.data)) {
//         setResultGroups(payload.data);
//       }

//       if (status === "completed") {
//         setLoadingResults(false);
//         setJobStatus("completed");
//         setJobError("");
//         toast.success("Bulk pricing processed successfully.");
//         return;
//       }

//       if (status === "failed") {
//         setLoadingResults(false);
//         setJobError(payload.message || "Bulk pricing processing failed.");
//         return;
//       }

//       // Keep showing the loader until processing finishes.
//       if (
//         ["waiting", "delayed", "active", "queued", "processing"].includes(
//           status
//         )
//       ) {
//         setLoadingResults(true);

//         pollTimeoutRef.current = setTimeout(() => {
//           fetchJobData(currentJobId);
//         }, POLL_INTERVAL);

//         return;
//       }

//       setLoadingResults(false);
//     } catch (error) {
//       console.error("Bulk pricing job error:", error);

//       if (activeJobRef.current !== currentJobId) return;

//       setJobError(
//         error?.response?.data?.message ||
//         error.message ||
//         "Unable to fetch processing results."
//       );

//       setLoadingResults(false);
//     }
//   }, []);

//   // =====================================================
//   // UPLOAD EXCEL FILE
//   // =====================================================

//   const handleFileUpload = async () => {
//     if (!selectedFile) {
//       toast.error("Please select an Excel file first.");
//       return;
//     }

//     if (pollTimeoutRef.current) {
//       clearTimeout(pollTimeoutRef.current);
//     }

//     activeJobRef.current = null;

//     setUploading(true);
//     setLoadingResults(false);
//     setJobId(null);
//     setJobStatus("");
//     setResultGroups([]);
//     setJobError("");

//     const formData = new FormData();
//     formData.append("file", selectedFile);

//     try {
//       const response = await axiosPost(
//         "/Parts/UploadBulkPricing",
//         formData,
//         apiHeaderFile
//       );

//       const payload = response?.data;

//       if (!payload?.success || !payload?.jobId) {
//         throw new Error(payload?.message || "Failed to upload Excel file.");
//       }

//       const newJobId = String(payload.jobId);

//       activeJobRef.current = newJobId;

//       setJobId(newJobId);
//       setJobStatus(payload.status || "queued");
//       setLoadingResults(true);
//       setSelectedFile(null);

//       toast.success("Excel uploaded successfully. Processing started.");

//       // Start checking the job status.
//       fetchJobData(newJobId);
//     } catch (error) {
//       console.error("Excel upload error:", error);

//       toast.error(
//         error?.response?.data?.message ||
//         error.message ||
//         "Error uploading Excel file."
//       );
//     } finally {
//       setUploading(false);
//     }
//   };

//   // =====================================================
//   // DOWNLOAD EXCEL TEMPLATE
//   // =====================================================

//   const downloadTemplate = () => {
//     const data = [
//       ["OE NUMBER"],
//       ["044650C020"],
//       ["0446502440"],
//     ];

//     const worksheet = XLSX.utils.aoa_to_sheet(data);
//     const workbook = XLSX.utils.book_new();

//     XLSX.utils.book_append_sheet(workbook, worksheet, "Template");

//     XLSX.writeFile(workbook, "OE_Number_Template.xlsx");
//   };

//   // =====================================================
//   // PARTS TABLE
//   // =====================================================

//   const renderPartsTable = (parts, oeNumber) => {
//     if (!parts || parts.length === 0) {
//       return (
//         <div className="alert alert-light border mb-0">
//           No matching parts found for this OE number.
//         </div>
//       );
//     }

//     return (
//       <div className="table-responsive">
//         <table className="table table-bordered table-striped mb-0">
//           <thead className="thead-light">
//             <tr>
//               <th style={{ minWidth: '30px', verticalAlign: 'middle' }}>SR No.</th>
//               <th style={{ verticalAlign: 'middle' }} width="400">Part Name</th>
//               <th style={{ minWidth: '150px', verticalAlign: 'middle' }}>Part Number</th>
//               <th style={{ minWidth: '150px', verticalAlign: 'middle' }}>Brand Name</th>
//               <th style={{ verticalAlign: 'middle' }}>Picture</th>
//               <th style={{ verticalAlign: 'middle' }}>Available QTY</th>
//               <th style={{ verticalAlign: 'middle' }}>
//                 Offer Price <small style={{ color: "red", fontWeight: "bold" }}>excl. 5.0% VAT</small>
//               </th>
//               <th style={{ verticalAlign: 'middle' }}>Details</th>
//               <th style={{ verticalAlign: 'middle' }}>Buy</th>
//             </tr>
//           </thead>

//           <tbody>
//             {parts.map((part, index) => {
//               const OE_part_slug = slugify(part?.PRODUCT_GROUP
//                 ?.toString()
//                 .trim()
//                 .replace(/,/g, "")
//                 .replace(/\s+/g, "-")
//                 .toLowerCase()
//               ) +
//                 "-" +
//                 slugify(`${part.ART_SEARCH_NUMBER}`.toLowerCase())
//                 +
//                 `/${part?.stock_brand_name}`
//                 ;

//               const part_slug = slugify(part?.PRODUCT_GROUP?.toString().trim().replace(/,/g, "").replace(/\s+/g, "-").toLowerCase()) +
//                 "-" +
//                 slugify(part?.ART_SEARCH_NUMBER?.toString().toLowerCase()) +
//                 "-" +
//                 slugify(part?.ART_SUP_ID?.toString().toLowerCase());

//               const url = part.ART_TYPE === 'OENumber' ? `/OE-Spare-Parts/Details/${OE_part_slug}` : `/Spare-Parts/Details/${part_slug}`

//               return (
//                 <tr
//                   key={`${oeNumber}-${part.ART_ID}-${part.ART_SUP_ID}-${index}`}
//                 >

//                   <td style={{ verticalAlign: 'middle' }}>{index + 1}</td>

//                   <td width="20%" style={{ verticalAlign: 'middle' }}>
//                     <NavLink to={url}>
//                       {part && part.PRODUCT_GROUP}
//                     </NavLink>
//                   </td>

//                   <td style={{ verticalAlign: 'middle' }}>{part.ART_ARTICLE_NR || "-"}</td>
//                   <td style={{ verticalAlign: 'middle' }}>{part.ART_SUP_BRAND || "-"}</td>

//                   <td>
//                     <NavLink to={url}>
//                       <img
//                         src={`${part.MEDIA_SOURCE ? part.MEDIA_SOURCE : apiURL + '/public/placeholder_category.jpeg'}`}
//                         style={{ width: '50px' }}
//                         alt={part?.PRODUCT_GROUP}
//                       />
//                     </NavLink>
//                   </td>

//                   <td style={{ verticalAlign: 'middle' }}>{part.VD_QTY ?? 0}</td>

//                   <td style={{ verticalAlign: 'middle' }}>
//                     <strong>
//                       {part.display_price || `${(Number(part.VD_BB_PRICE) || 0).toFixed(2)}`}
//                     </strong>
//                   </td>

//                   <td style={{ verticalAlign: 'middle' }}>
//                     <button
//                       type="button"
//                       className="btn btn-sm btn-info mr-1 mb-1"
//                       data-toggle="modal"
//                       data-target="#infoModal"
//                       onClick={() => navigate(url)}
//                     >
//                       <i className="fas fa-info-circle mr-1" />
//                       Info
//                     </button>
//                   </td>
//                   <td style={{ verticalAlign: 'middle' }}>
//                     <button
//                       type="button"
//                       className="btn btn-sm btn-dark"
//                       onClick={() => handleAddToCart(part, url)}
//                       disabled={
//                         addToCartLoading ||
//                         isAddingRef.current ||
//                         (business_type === 1
//                           ? Number(part.stock_bg_price) === 0
//                           : Number(part.stock_bb_price) === 0)
//                       }
//                     >
//                       <i className="fas fa-cart-plus mr-1" />
//                       BUY
//                     </button>
//                   </td>
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>
//       </div>
//     );
//   };



//   const DownloadResultsExcel = () => {
//     if (!resultGroups.length) {
//       toast.error("No results available to download.");
//       return;
//     }

//     const rows = [];

//     resultGroups.forEach((group, index) => {
//       const oeNumber = group.oeNumber || group.oe_number || "-";
//       const parts = Array.isArray(group.parts) ? group.parts : [];

//       // Section number
//       rows.push([String(index + 1)]);

//       // Input details + results heading
//       rows.push([
//         "OE Part no",
//         "part name",
//         "brand",
//         "",
//         "results",
//       ]);

//       // Input OE details and result column headers
//       rows.push([
//         oeNumber,
//         "",
//         "",
//         "",
//         "sr no",
//         "OE/Afm part No",
//         "part name",
//         "brand name",
//         "price in usd",
//         "quantity",
//       ]);

//       if (parts.length) {
//         parts.forEach((part, partIndex) => {
//           rows.push([
//             "",
//             "",
//             "",
//             "",
//             partIndex + 1,
//             part.ART_SEARCH_NUMBER || part.ART_ARTICLE_NR || "-",
//             part.PRODUCT_GROUP || "-",
//             part.ART_SUP_BRAND || part.stock_brand_name || "-",
//             part.display_price ??
//             part.VD_BB_PRICE ??
//             part.VD_BG_PRICE ??
//             0,
//             part.VD_QTY ?? 0,
//           ]);
//         });
//       } else {
//         rows.push([
//           "",
//           "",
//           "",
//           "",
//           "not available",
//         ]);
//       }

//       // Blank row between OE sections
//       rows.push([]);
//     });

//     const worksheet = XLSX.utils.aoa_to_sheet(rows);

//     worksheet["!cols"] = [
//       { wch: 18 },
//       { wch: 18 },
//       { wch: 16 },
//       { wch: 3 },
//       { wch: 10 },
//       { wch: 22 },
//       { wch: 25 },
//       { wch: 20 },
//       { wch: 18 },
//       { wch: 12 },
//     ];

//     const workbook = XLSX.utils.book_new();

//     XLSX.utils.book_append_sheet(
//       workbook,
//       worksheet,
//       "Bulk Pricing Results"
//     );

//     XLSX.writeFile(workbook, "Bulk_Pricing_Results.xlsx");
//   };


//   // =====================================================
//   // UI
//   // =====================================================

//   return (
//     <div className="header-bottom">
//       <Helmet>
//         <title>Get Bulk Price List</title>
//       </Helmet>

//       <div className="container py-3">
//         {/* Page header */}
//         <div className="row align-items-center mb-3">
//           <div className="col-md-6">
//             <h4 className="mb-1">Bulk Price List</h4>
//             <p className="text-muted mb-0">
//               Upload an Excel file to find prices for multiple OE numbers.
//             </p>
//           </div>

//           <div className="col-md-6 text-md-right mt-3 mt-md-0">
//             <button
//               type="button"
//               className="btn btn-outline-success"
//               onClick={downloadTemplate}
//               disabled={uploading || loadingResults}
//             >
//               <i className="fas fa-file-excel mr-2" />
//               Download Sample File
//             </button>
//           </div>
//         </div>

//         {/* Excel upload */}
//         <div className="card mb-4">
//           <div className="card-body">
//             <div
//               className="p-3"
//               style={{
//                 border: "2px dashed #ced4da",
//                 borderRadius: "6px",
//                 backgroundColor: "#f8f9fa",
//               }}
//             >
//               <div className="row align-items-center">


//                 <div className="col-lg-8">
//                   <label htmlFor="bulkPricingFile" className="font-weight-bold">
//                     Select Excel File
//                   </label>

//                   <div
//                     className="position-relative"
//                     style={{
//                       height: "40px",
//                       border: "1px solid #ced4da",
//                       borderRadius: "4px",
//                       backgroundColor: "#fff",
//                       overflow: "hidden",
//                       cursor: "pointer"
//                     }}
//                   >
//                     <input
//                       type="file"
//                       id="bulkPricingFile"
//                       accept=".xlsx,.xls"
//                       onChange={handleFileChange}
//                       disabled={uploading || loadingResults}
//                       style={{
//                         position: "absolute",
//                         inset: 0,
//                         width: "100%",
//                         height: "100%",
//                         opacity: 0,
//                         cursor: "pointer",
//                         zIndex: 2,
//                       }}
//                     />

//                     <div
//                       className="d-flex align-items-center pl-3"
//                       style={{
//                         height: "100%",
//                         color: "#495057",
//                         fontSize: "14px",
//                       }}
//                     >
//                       {selectedFile ? selectedFile.name : "Choose Excel file"}
//                     </div>
//                   </div>

//                   <small className="form-text text-muted mt-2">
//                     Excel file must contain an <strong>OE NUMBER</strong> column.
//                     Download the sample file for the correct format.
//                   </small>
//                 </div>

//                 <div className="col-lg-4 mt-2 mt-lg-0">
//                   <button
//                     type="button"
//                     className="btn btn-primary btn-block"
//                     onClick={handleFileUpload}
//                     disabled={
//                       !selectedFile || uploading || loadingResults
//                     }
//                   >
//                     {uploading ? (
//                       <>
//                         <span
//                           className="spinner-border spinner-border-sm mr-2"
//                           role="status"
//                           aria-hidden="true"
//                         />
//                         Uploading...
//                       </>
//                     ) : (
//                       <>
//                         <i className="fas fa-upload mr-2" />
//                         Upload Excel
//                       </>
//                     )}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Loading: visible only while processing */}
//         {loadingResults && (
//           <div className="card mb-4">
//             <div className="card-body text-center py-5">
//               <div
//                 className="spinner-border text-primary mb-3"
//                 role="status"
//                 aria-hidden="true"
//                 style={{ width: "3rem", height: "3rem" }}
//               />

//               <h5 className="mb-2">Processing your Excel file...</h5>

//               <p className="text-muted mb-0">
//                 Please wait while we find matching parts and prices.
//               </p>
//             </div>
//           </div>
//         )}

//         {/* Error */}
//         {!loadingResults && jobError && (
//           <div className="alert alert-danger">
//             <i className="fas fa-exclamation-circle mr-2" />
//             {jobError}

//             {jobId && (
//               <button
//                 type="button"
//                 className="btn btn-sm btn-outline-danger ml-2"
//                 onClick={() => {
//                   setJobError("");
//                   setLoadingResults(true);
//                   fetchJobData(jobId);
//                 }}
//               >
//                 Retry
//               </button>
//             )}
//           </div>
//         )}

//         {/* No matching parts */}
//         {jobId &&
//           !loadingResults &&
//           !jobError &&
//           jobStatus === "completed" &&
//           resultGroups.length === 0 && (
//             <div className="alert alert-warning">
//               <i className="fas fa-info-circle mr-2" />
//               Processing completed, but no matching parts were found.
//             </div>
//           )}

//         {/* Grouped results: each uploaded OE gets its own section */}
//         {!loadingResults &&
//           resultGroups.map((group, index) => {
//             const oeNumber = group.oeNumber || group.oe_number || "-";
//             const parts = Array.isArray(group.parts) ? group.parts : [];

//             return (
//               <div
//                 className="card mb-4"
//                 key={`${oeNumber}-${index}`}
//               >

//                 <div className="card-header bg-white">
//                   <div className="d-flex flex-wrap justify-content-between align-items-center">
//                     <h6 className="font-weight-bold">
//                       <i className="fas fa-barcode text-primary mr-2" />
//                       OE Number: {oeNumber}
//                     </h6>
//                   </div>
//                 </div>

//                 <div className="card-body">
//                   {renderPartsTable(parts, oeNumber)}
//                 </div>
//               </div>
//             );
//           })}
//       </div>
//     </div>
//   );
// };

// export default BulkPricing;


import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { ConfigContext } from "../../Context/ConfigContext";
import slugify from "slugify";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import { AddToCartNotifier } from "../../Components/CartComponents";
import * as XLSX from "xlsx";
import { axiosGet, axiosPost } from "../../Apis/axiosMethods";
import { CartsContext } from "../../Context/CartsContext";

const POLL_INTERVAL = 2000;

const BulkPricing = () => {
  const {
    apiURL,
    setIsCartDropdownOpen,
    apiHeaderFile,
    currency,
    business_type,
  } = useContext(ConfigContext);

  const { AddToCart, GetCartItemQty, GetStockPolicyItem } =
    useContext(CartsContext);

  const navigate = useNavigate();
  const isAddingRef = useRef(false);
  const pollTimeoutRef = useRef(null);
  const activeJobRef = useRef(null);

  const [addToCartLoading, setAddToCartLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [loadingResults, setLoadingResults] = useState(false);
  const [jobId, setJobId] = useState(null);
  const [jobStatus, setJobStatus] = useState("");
  const [resultGroups, setResultGroups] = useState([]);
  const [jobError, setJobError] = useState("");

  useEffect(() => {
    return () => {
      if (pollTimeoutRef.current) clearTimeout(pollTimeoutRef.current);
    };
  }, []);

  // =====================================================
  // ADD TO CART
  // =====================================================

  const handleAddToCart = async (part, url) => {
    if (isAddingRef.current) return;
    isAddingRef.current = true;

    try {
      setAddToCartLoading(true);

      const previousQty = Number(
        (await GetCartItemQty(part?.ART_SEARCH_NUMBER)) || 0
      );
      const stock = Number(part?.VD_QTY || 0);

      if (!stock) {
        toast.info(
          <AddToCartNotifier
            item_name="We don't have stock for this part"
            item_img=""
          />
        );
        return;
      }

      const stockPolicy = await GetStockPolicyItem(
        part?.ART_SEARCH_NUMBER,
        part?.stock_oe,
        part?.ART_SUP_ID,
        part?.ART_SUP_BRAND
      );

      const minQty = Number(stockPolicy?.policy_min_qty || 1);
      const remainingStock = stock - previousQty;
      let addQty = minQty;

      if (remainingStock < minQty && remainingStock > 0) addQty = remainingStock;

      if (remainingStock <= 0 || remainingStock < addQty) {
        toast.info(
          <AddToCartNotifier
            item_name="We don't have enough stock for this part"
            item_img=""
          />
        );
        return;
      }

      const partImg =
        part?.MEDIA_SOURCE ||
        `${apiURL}/public/placeholder_category.jpeg`;

      const item = {
        ART_ID: part?.ART_ID,
        ART_ARTICLE_NR: part?.ART_SEARCH_NUMBER,
        PRODUCT_GROUP_EN: part?.PRODUCT_GROUP,
        stock_price_mrp: part?.VD_PRICE_MRP,
        VD_BB_PRICE: part?.VD_BB_PRICE,
        VD_BG_PRICE: part?.VD_BG_PRICE,
        ART_SUP_ID: part?.ART_SUP_ID || 0,
        ART_SUP_BRAND: part?.ART_SUP_BRAND,
        inventory_store_id: part?.inventory_store_id,
        stock_oe: part?.stock_oe ?? 0,
        VD_QTY: stock,
        stock_delivery_days: part?.stock_delivery_days,
      };

      await AddToCart(item, addQty, partImg, url);
      setIsCartDropdownOpen(true);
      window.scrollTo(0, 0);
    } catch (error) {
      console.error("handleAddToCart Error:", error);
      toast.error("Unable to add this part to cart.");
    } finally {
      setAddToCartLoading(false);
      isAddingRef.current = false;
    }
  };

  // =====================================================
  // SELECT EXCEL FILE
  // =====================================================

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];

    if (!file) {
      setSelectedFile(null);
      return;
    }

    if (!/\.(xlsx|xls)$/i.test(file.name)) {
      toast.error("Please select a valid Excel file (.xlsx or .xls).");
      event.target.value = "";
      setSelectedFile(null);
      return;
    }

    setSelectedFile(file);
    setJobError("");
  };

  // =====================================================
  // FETCH BACKGROUND JOB RESULT
  // =====================================================

  const fetchJobData = useCallback(
    async (currentJobId) => {
      if (!currentJobId) return;

      try {
        const response = await axiosGet("/Parts/GetBulkPricingJobResult", { jobId: currentJobId, currency });

        const payload = response?.data;

        if (!payload?.success) {
          throw new Error(
            payload?.message || "Unable to retrieve processing status."
          );
        }

        if (activeJobRef.current !== currentJobId) return;

        const status = String(payload.status || "processing").toLowerCase();
        setJobStatus(status);

        if (Array.isArray(payload.data)) setResultGroups(payload.data);

        if (status === "completed") {
          setLoadingResults(false);
          setJobStatus("completed");
          setJobError("");
          toast.success("Bulk pricing processed successfully.");
          return;
        }

        if (status === "failed") {
          setLoadingResults(false);
          setJobError(payload.message || "Bulk pricing processing failed.");
          return;
        }

        if (
          ["waiting", "delayed", "active", "queued", "processing"].includes(
            status
          )
        ) {
          setLoadingResults(true);
          pollTimeoutRef.current = setTimeout(
            () => fetchJobData(currentJobId),
            POLL_INTERVAL
          );
          return;
        }

        setLoadingResults(false);
      } catch (error) {
        console.error("Bulk pricing job error:", error);
        if (activeJobRef.current !== currentJobId) return;

        setJobError(
          error?.response?.data?.message ||
          error.message ||
          "Unable to fetch processing results."
        );
        setLoadingResults(false);
      }
    },
    [currency]
  );

  // =====================================================
  // UPLOAD EXCEL FILE
  // =====================================================

  const handleFileUpload = async () => {
    if (!selectedFile) {
      toast.error("Please select an Excel file first.");
      return;
    }

    if (pollTimeoutRef.current) clearTimeout(pollTimeoutRef.current);

    activeJobRef.current = null;
    setUploading(true);
    setLoadingResults(false);
    setJobId(null);
    setJobStatus("");
    setResultGroups([]);
    setJobError("");

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("currency", currency);

    try {
      const response = await axiosPost(
        "/Parts/UploadBulkPricing",
        formData,
        apiHeaderFile
      );
      const payload = response?.data;

      if (!payload?.success || !payload?.jobId) {
        throw new Error(payload?.message || "Failed to upload Excel file.");
      }

      const newJobId = String(payload.jobId);
      activeJobRef.current = newJobId;
      setJobId(newJobId);
      setJobStatus(payload.status || "queued");
      setLoadingResults(true);
      setSelectedFile(null);

      const fileInput = document.getElementById("bulkPricingFile");
      if (fileInput) fileInput.value = "";

      toast.success("Excel uploaded successfully. Processing started.");
      fetchJobData(newJobId);
    } catch (error) {
      console.error("Excel upload error:", error);
      toast.error(
        error?.response?.data?.message ||
        error.message ||
        "Error uploading Excel file."
      );
    } finally {
      setUploading(false);
    }
  };

  // =====================================================
  // DOWNLOAD SAMPLE TEMPLATE
  // =====================================================

  const downloadTemplate = () => {
    const worksheet = XLSX.utils.aoa_to_sheet([
      ["OE NUMBER"],
      ["044650C020"],
      ["0446502440"],
    ]);
    worksheet["!cols"] = [{ wch: 24 }];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Template");
    XLSX.writeFile(workbook, "OE_Number_Template.xlsx");
  };

  // =====================================================
  // DOWNLOAD ACTUAL RESULTS
  // =====================================================

  const downloadResultsExcel = () => {
    if (!resultGroups.length) {
      toast.error("No results available to download.");
      return;
    }

    const rows = [];

    resultGroups.forEach((group, groupIndex) => {
      const oeNumber = group.oeNumber || group.oe_number || "-";
      const parts = Array.isArray(group.parts) ? group.parts : [];

      rows.push([String(groupIndex + 1)]);
      rows.push(["OE Part no", "", "results"]);

      rows.push([
        oeNumber,
        "",
        "sr no",
        "OE/Afm part No",
        "part name",
        "brand name",
        `price in ${String(currency || "AED").toLowerCase()}`,
        "quantity",
      ]);

      if (parts.length > 0) {
        parts.forEach((part, partIndex) => {
          const displayPrice =
            part.display_price ??
            (Number(part.VD_BB_PRICE || 0).toFixed(2));

          rows.push([
            "",
            "",
            partIndex + 1,
            part.ART_SEARCH_NUMBER || part.ART_ARTICLE_NR || "-",
            part.PRODUCT_GROUP || "-",
            part.ART_SUP_BRAND || part.stock_brand_name || "-",
            displayPrice,
            Number(part.VD_QTY ?? part.quantity ?? 0),
          ]);
        });
      } else {
        rows.push(["", "", "", "", "not available"]);
      }

      rows.push([]);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(rows);

    worksheet["!cols"] = [
      { wch: 18 },
      { wch: 18 },
      { wch: 16 },
      { wch: 3 },
      { wch: 10 },
      { wch: 22 },
      { wch: 25 },
      { wch: 20 },
      { wch: 20 },
      { wch: 12 },
    ];

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Bulk Pricing Results"
    );

    XLSX.writeFile(workbook, "Bulk_Pricing_Results.xlsx");
  };

  // =====================================================
  // PARTS TABLE
  // =====================================================

  const renderPartsTable = (parts, oeNumber) => {
    if (!parts?.length) {
      return (
        <div className="alert alert-light border mb-0">
          No matching parts found for this OE number.
        </div>
      );
    }

    return (
      <div className="table-responsive">
        <table className="table table-bordered table-striped mb-0">
          <thead className="thead-light">
            <tr>
              <th style={{ minWidth: 60, verticalAlign: "middle" }}>SR No.</th>
              <th style={{ minWidth: 240, verticalAlign: "middle" }}>Part Name</th>
              <th style={{ minWidth: 150, verticalAlign: "middle" }}>Part Number</th>
              <th style={{ minWidth: 150, verticalAlign: "middle" }}>Brand Name</th>
              <th style={{ verticalAlign: "middle" }}>Picture</th>
              <th style={{ verticalAlign: "middle" }}>Available QTY</th>
              <th style={{ minWidth: 160, verticalAlign: "middle" }}>
                Offer Price{" "}
                <small style={{ color: "red", fontWeight: "bold" }}>
                  excl. 5.0% VAT
                </small>
              </th>
              <th style={{ verticalAlign: "middle" }}>Details</th>
              <th style={{ verticalAlign: "middle" }}>Buy</th>
            </tr>
          </thead>
          <tbody>
            {parts.map((part, index) => {
              const productSlug = slugify(
                (part?.PRODUCT_GROUP || "").toString().trim().replace(/,/g, "")
              );
              const articleSlug = slugify(
                (part?.ART_SEARCH_NUMBER || "").toString()
              );
              const supplierSlug = slugify(
                (part?.ART_SUP_ID ?? "").toString()
              );

              const oePartSlug = `${productSlug}-${articleSlug}/${encodeURIComponent(
                part?.stock_brand_name || ""
              )}`;
              const regularPartSlug = `${productSlug}-${articleSlug}-${supplierSlug}`;
              const url =
                part.ART_TYPE === "OENumber"
                  ? `/OE-Spare-Parts/Details/${oePartSlug}`
                  : `/Spare-Parts/Details/${regularPartSlug}`;

              const hasPrice =
                Number(business_type) === 1
                  ? Number(part.stock_bg_price ?? part.VD_BG_PRICE ?? 0) > 0
                  : Number(part.stock_bb_price ?? part.VD_BB_PRICE ?? 0) > 0;

              return (
                <tr key={`${oeNumber}-${part.ART_ID}-${part.ART_SUP_ID}-${index}`}>
                  <td style={{ verticalAlign: "middle" }}>{index + 1}</td>
                  <td style={{ verticalAlign: "middle" }}>
                    <NavLink to={url}>{part.PRODUCT_GROUP || "-"}</NavLink>
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    {part.ART_SEARCH_NUMBER || part.ART_ARTICLE_NR || "-"}
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    {part.ART_SUP_BRAND || part.stock_brand_name || "-"}
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <NavLink to={url}>
                      <img
                        src={
                          part.MEDIA_SOURCE ||
                          `${apiURL}/public/placeholder_category.jpeg`
                        }
                        style={{ width: 50 }}
                        alt={part.PRODUCT_GROUP || "Part"}
                      />
                    </NavLink>
                  </td>
                  <td style={{ verticalAlign: "middle" }}>{part.VD_QTY ?? 0}</td>
                  <td style={{ verticalAlign: "middle" }}>
                    <strong>
                      {part.display_price ??
                        Number(part.VD_BB_PRICE || 0).toFixed(2)}
                    </strong>
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <button
                      type="button"
                      className="btn btn-sm btn-info"
                      onClick={() => navigate(url)}
                    >
                      <i className="fas fa-info-circle mr-1" />
                      Info
                    </button>
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <button
                      type="button"
                      className="btn btn-sm btn-dark"
                      onClick={() => handleAddToCart(part, url)}
                      disabled={addToCartLoading || isAddingRef.current || !hasPrice}
                    >
                      <i className="fas fa-cart-plus mr-1" />
                      BUY
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  // =====================================================
  // UI
  // =====================================================

  return (
    <div className="header-bottom">
      <Helmet>
        <title>Get Bulk Price List</title>
      </Helmet>

      <div className="container py-3">
        <div className="row align-items-center mb-3">
          <div className="col-md-6">
            <h4 className="mb-1">Bulk Price List</h4>
            <p className="text-muted mb-0">
              Upload an Excel file to find prices for multiple OE numbers.
            </p>
          </div>
          <div className="col-md-6 text-md-right mt-3 mt-md-0">
            <button
              type="button"
              className="btn btn-outline-success mr-2 mb-2"
              onClick={downloadTemplate}
              disabled={uploading || loadingResults}
            >
              <i className="fas fa-file-download mr-2" />
              Download Sample File
            </button>
            <button
              type="button"
              className="btn btn-info mb-2"
              onClick={downloadResultsExcel}
              disabled={!resultGroups.length || loadingResults}
            >
              <i className="fas fa-file-excel mr-2" />
              Download Results Excel
            </button>
          </div>
        </div>

        <div className="card mb-4">
          <div className="card-body">
            <div
              className="p-3"
              style={{
                border: "2px dashed #ced4da",
                borderRadius: 6,
                backgroundColor: "#f8f9fa",
              }}
            >
              <div className="row align-items-center">
                <div className="col-lg-8">
                  <label htmlFor="bulkPricingFile" className="font-weight-bold">
                    Select Excel File
                  </label>
                  <div
                    className="position-relative"
                    style={{
                      height: 40,
                      border: "1px solid #ced4da",
                      borderRadius: 4,
                      backgroundColor: "#fff",
                      overflow: "hidden",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="file"
                      id="bulkPricingFile"
                      accept=".xlsx,.xls"
                      onChange={handleFileChange}
                      disabled={uploading || loadingResults}
                      style={{
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        opacity: 0,
                        cursor: "pointer",
                        zIndex: 2,
                      }}
                    />
                    <div
                      className="d-flex align-items-center pl-3"
                      style={{ height: "100%", color: "#495057", fontSize: 14 }}
                    >
                      {selectedFile ? selectedFile.name : "Choose Excel file"}
                    </div>
                  </div>
                  <small className="form-text text-muted mt-2">
                    Excel file must contain an <strong>OE NUMBER</strong> column.
                    Download the sample file for the correct format.
                  </small>
                </div>
                <div className="col-lg-4 mt-2 mt-lg-0">
                  <button
                    type="button"
                    className="btn btn-primary btn-block"
                    onClick={handleFileUpload}
                    disabled={!selectedFile || uploading || loadingResults}
                  >
                    {uploading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm mr-2"
                          role="status"
                          aria-hidden="true"
                        />
                        Uploading...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-upload mr-2" />
                        Upload Excel
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {loadingResults && (
          <div className="card mb-4">
            <div className="card-body text-center py-5">
              <div
                className="spinner-border text-primary mb-3"
                role="status"
                aria-hidden="true"
                style={{ width: "3rem", height: "3rem" }}
              />
              <h5 className="mb-2">Processing your Excel file...</h5>
              <p className="text-muted mb-0">
                Please wait while we find matching parts and prices.
              </p>
            </div>
          </div>
        )}

        {!loadingResults && jobError && (
          <div className="alert alert-danger">
            <i className="fas fa-exclamation-circle mr-2" />
            {jobError}
            {jobId && (
              <button
                type="button"
                className="btn btn-sm btn-outline-danger ml-2"
                onClick={() => {
                  setJobError("");
                  setLoadingResults(true);
                  fetchJobData(jobId);
                }}
              >
                Retry
              </button>
            )}
          </div>
        )}

        {jobId &&
          !loadingResults &&
          !jobError &&
          jobStatus === "completed" &&
          resultGroups.length === 0 && (
            <div className="alert alert-warning">
              <i className="fas fa-info-circle mr-2" />
              Processing completed, but no matching parts were found.
            </div>
          )}

        {!loadingResults &&
          resultGroups.map((group, index) => {
            const oeNumber = group.oeNumber || group.oe_number || "-";
            const parts = Array.isArray(group.parts) ? group.parts : [];

            return (
              <div className="card mb-4" key={`${oeNumber}-${index}`}>
                <div className="card-header bg-white">
                  <h6 className="font-weight-bold mb-0">
                    <i className="fas fa-barcode text-primary mr-2" />
                    OE Number: {oeNumber}
                  </h6>
                </div>
                <div className="card-body">{renderPartsTable(parts, oeNumber)}</div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default BulkPricing;
